const ROLES_CLAIM = 'urn:zitadel:iam:org:project:roles';

export const getRoles = (user) =>
  Object.keys(user?.profile?.[ROLES_CLAIM] ?? {});
